export const HIERARCHY_GRADES_ENUM = {
  PRE_K: 'PRE_K',
  KINDERGARTEN: 'KINDERGARTEN',
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  THIRD: 'THIRD',
  FOURTH: 'FOURTH',
  FIFTH: 'FIFTH',
  SIXTH: 'SIXTH',
  SEVENTH: 'SEVENTH',
  EIGHTH: 'EIGHTH',
  NINTH: 'NINTH',
  TENTH: 'TENTH',
  ELEVENTH: 'ELEVENTH',
  TWELFTH: 'TWELFTH',
  THIRTEENTH: 'THIRTEENTH',
  FOURTEENTH: 'FOURTEENTH',
  FIFTEENTH: 'FIFTEENTH',
  STAFF: 'STAFF',
};

export const HIERARCHY_GRADES_ENUM_LABELS = {
  PRE_K: 'Pre-K',
  KINDERGARTEN: 'Kindergarten',
  FIRST: 'First',
  SECOND: 'Second',
  THIRD: 'Third',
  FOURTH: 'Fourth',
  FIFTH: 'Fifth',
  SIXTH: 'Sixth',
  SEVENTH: 'Seventh',
  EIGHTH: 'Eighth',
  NINTH: 'Ninth',
  TENTH: 'Tenth',
  ELEVENTH: 'Eleventh',
  TWELFTH: 'Twelfth',
  THIRTEENTH: 'Thirteenth',
  FOURTEENTH: 'Fourteenth',
  FIFTEENTH: 'Fifteenth',
  STAFF: 'Staff',
};

export const HIERARCHY_GRADES_ORDINAL_ENUM = {
  PRE_K: 'PRE_K',
  KINDERGARTEN: 'KINDERGARTEN',
  '1st': 'FIRST',
  '2nd': 'SECOND',
  '3rd': 'THIRD',
  '4th': 'FOURTH',
  '5th': 'FIFTH',
  '6th': 'SIXTH',
  '7th': 'SEVENTH',
  '8th': 'EIGHTH',
  '9th': 'NINTH',
  '10th': 'TENTH',
  '11th': 'ELEVENTH',
  '12th': 'TWELFTH',
  '13th': 'THIRTEENTH',
  '14th': 'FOURTEENTH',
  '15th': 'FIFTEENTH',
};

export const HIERARCHY_GRADES_NUMBERED_ENUM = {
  PRE_K: 'PRE_K',
  KINDERGARTEN: 'KINDERGARTEN',
  1: 'FIRST',
  2: 'SECOND',
  3: 'THIRD',
  4: 'FOURTH',
  5: 'FIFTH',
  6: 'SIXTH',
  7: 'SEVENTH',
  8: 'EIGHTH',
  9: 'NINTH',
  10: 'TENTH',
  11: 'ELEVENTH',
  12: 'TWELFTH',
  13: 'THIRTEENTH',
  14: 'FOURTEENTH',
  15: 'FIFTEENTH',
};

export const HIERARCHY_GRADES_REQUIRING_CLASS = [
  HIERARCHY_GRADES_ENUM.KINDERGARTEN,
  HIERARCHY_GRADES_ENUM.PRE_K,
  HIERARCHY_GRADES_ENUM.FIRST,
  HIERARCHY_GRADES_ENUM.SECOND,
  HIERARCHY_GRADES_ENUM.THIRD,
  HIERARCHY_GRADES_ENUM.FOURTH,
  HIERARCHY_GRADES_ENUM.FIFTH,
];
